import { DetectedEvent } from '@ais-ui/websockets';
import { AccordionContent, Separator } from '@ais-ui/ui-core';
import { ShipEventItem } from './ShipEventItem';
import { EventDetailsItem } from './EventDetailsItem';
import React from 'react';

interface EventItemContentProps {
  event: DetectedEvent;
}

export const EventItemContent = ({ event }: EventItemContentProps) => {
  return (
    <AccordionContent>
      <div className="grid gap-6 px-4 pt-4">
        <div className="grid gap-4">
          <div>
            <h3 className="font-medium text-base">Detected Ship</h3>
            <Separator className="mt-2"></Separator>
          </div>
          <ShipEventItem event={event}></ShipEventItem>
        </div>
        <div className="grid gap-4">
          <div>
            <h3 className="font-medium text-base">Event</h3>
            <Separator className="mt-2"></Separator>
          </div>
          <EventDetailsItem event={event}></EventDetailsItem>
        </div>
      </div>
    </AccordionContent>
  );
};
